import React, { useEffect, useState } from 'react';
import "./index.scss"
import { Tooltip as ReactTooltip } from 'react-tooltip'
import classNames from 'classnames';

const CustomTooltip = ({ id, label = "", tooltipClassName = "", show = false, alwaysShow = false, timeout = 4000 }) => {
    const [showTooltip, setShowTooltip] = useState(false)
    useEffect(() => {
        if(timeout){
            if(show){
                setShowTooltip(true)
                setTimeout(() => {
                    setShowTooltip(false)
                }, timeout);
            }
            else{ setShowTooltip(false) }
        } else { setShowTooltip(show) }
        // eslint-disable-next-line
    }, [show])
    return (
        <ReactTooltip isOpen={true} place="top" id={id} className={classNames("ft-tooltip custom-tooltip", tooltipClassName, (showTooltip || alwaysShow ? "d-block" : "d-none"))} clickable={true}>
            {label}
        </ReactTooltip>
    );
};

export default CustomTooltip;